import { useQuery } from '@tanstack/react-query';
import useGlynt from '../useGlynt';

export interface AvailableColumn {
  name: string;
  type: string;
  description: string;
  filter_conditions?: string[];
  supports_split_by?: boolean;
}

const useGetAvailableColumns = (
  dataPoolId: string,
  packagerId: string,
  reportType: string,
  enabled: boolean = true
) => {
  const glynt = useGlynt();

  // mat_ct merges org-scoped dynamic c_extra MAT keys cached server-side for 5 min.
  // Match the staleTime so the UI can pick up newly-ingested keys within one server TTL window.
  // dataPoolId is part of the key, which transitively scopes by org (no cross-org leakage).
  const queryResult = useQuery({
    queryKey: ['availableColumns', dataPoolId, packagerId, reportType],
    queryFn: async () => await (await glynt).packager.availableColumns(dataPoolId, packagerId, reportType),
    enabled: enabled && !!dataPoolId && !!packagerId && !!reportType,
    refetchOnWindowFocus: false,

    gcTime: 1000 * 60 * 60,
    staleTime: 1000 * 60 * 5,
  });

  const columns = queryResult.data || [];

  return {
    ...queryResult,
    columns,
  };
};

export default useGetAvailableColumns;
